import PropTypes from 'prop-types';

import { Modal } from 'jl-design-system/components/modal/Modal';

export const CancelAppointmentModal = ({ rejectHandler, confirmHandler, selectedBooking }) => (
  <Modal
    isOpen
    title="Cancel your appointment"
    onClose={rejectHandler}
    rootId="page-root"
    footerLayout="inline"
    primaryButtonText="Yes, cancel"
    underlinedButtonText="No, keep appointment"
    onPrimaryButtonClick={confirmHandler}
    onUnderlinedButtonClick={rejectHandler}
    variant="standard"
  >
    <div id="modal-window">
      <p>
        Are you sure you want to cancel your <b>{selectedBooking.name} appointment?</b>
      </p>
    </div>
  </Modal>
);

CancelAppointmentModal.propTypes = {
  confirmHandler: PropTypes.func.isRequired,
  rejectHandler: PropTypes.func.isRequired,
  selectedBooking: PropTypes.object.isRequired,
};
